<div class="chart-js-responsive-container">
  <canvas
    baseChart
    [datasets]="chartData"
    [labels]="chartLabels"
    [options]="chartOptions"
    [legend]="false"
    [type]="'bar'"
    (chartClick)="onChartClick($event)"
  ></canvas>
</div>
